<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    persistent
    @keydown.esc="cancel"
  >
    <card>
      <card-title large closeable @click:close="dialog = false">
        {{ title }}
      </card-title>
      <card-content>
        <div
          v-show="!!message"
          class="subtitle-1 grey--text text--darken-4 font-weight-regular"
        >
          {{ message }}
        </div>
      </card-content>
      <card-actions>
        <v-spacer></v-spacer>
        <v-btn
          id="confirm-btn-cancel"
          color="primary"
          depressed
          outlined
          @click.native="cancel"
        >
          Отменить
        </v-btn>
        <v-btn
          id="confirm-btn-agree"
          color="primary"
          depressed
          @click.native="agree"
        >
          Применить
        </v-btn>
      </card-actions>
    </card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        color: "primary",
        width: 450,
        zIndex: 200
      }
    };
  },
  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = { ...this.options, ...options };
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }
};
</script>
